import { z } from 'zod';

export const ApprovalRequestTypeSchema = z.enum([
  'ANTICIPATION',
  'COLLECTION_DIVERGENCE',
  'MANUAL_ADJUSTMENT',
  'SAFE_OPENING',
  'TENANT_SUSPENSION',
]);

export type ApprovalRequestType = z.infer<typeof ApprovalRequestTypeSchema>;

export const ApprovalStatusSchema = z.enum([
  'PENDING_1',
  'PENDING_2',
  'APPROVED',
  'REJECTED',
  'EXPIRED',
  'CANCELLED',
]);

export type ApprovalStatus = z.infer<typeof ApprovalStatusSchema>;

export const ApprovalStepSchema = z.object({
  approverId: z.string().nullable(),
  approvedAt: z.string().datetime().nullable(),
  justification: z.string().nullable(),
  ipAddress: z.string().nullable(),
});

export type ApprovalStep = z.infer<typeof ApprovalStepSchema>;

export const ApprovalRequestSchema = z.object({
  requestId: z.string().uuid(),
  type: ApprovalRequestTypeSchema,
  status: ApprovalStatusSchema,
  requiredSteps: z.union([z.literal(1), z.literal(2)]),
  requestedBy: z.string().min(1),
  requestedAt: z.string().datetime(),
  expiresAt: z.string().datetime(),
  timeoutHours: z.number().positive(),
  tenantId: z.string().min(1),
  safeId: z.string().optional(),
  operationRef: z.string().min(1),
  payload: z.record(z.unknown()),
  step1: ApprovalStepSchema,
  step2: ApprovalStepSchema.nullable(),
  stepFunctions: z.object({
    executionArn: z.string().min(1),
    taskToken1: z.string().min(1),
    taskToken2: z.string().nullable(),
  }),
  auditHash: z.string().min(1),
});

export type ApprovalRequest = z.infer<typeof ApprovalRequestSchema>;

export const APPROVAL_TIMEOUT_HOURS: Record<ApprovalRequestType, number> = {
  ANTICIPATION: 4,
  COLLECTION_DIVERGENCE: 4,
  MANUAL_ADJUSTMENT: 4,
  SAFE_OPENING: 0.25,
  TENANT_SUSPENSION: 8,
};
